import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faArrowUp,
  faArrowDown,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";

const ActivityProactiveRatio = ({ activityRatio, proactiveRatio }) => {
  console.log(activityRatio, proactiveRatio);
  const renderDelta = (delta, unit = "") => {
    const isUp = delta > 0;
    const isDown = delta < 0;

    const color = isUp ? "#22c55e" : isDown ? "#ef4444" : "#6b7280";

    return (
      <div className="flex items-center gap-1 text-sm font-medium">
        <FontAwesomeIcon
          icon={isUp ? faArrowUp : faArrowDown}
          style={{ color }}
        />
        <span style={{ color }}>
          {Math.abs(delta)}
          {unit}
        </span>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* ===== ACTIVITY RATIO ===== */}
      <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-3 rounded-lg bg-blue-50">
            <FontAwesomeIcon
              icon={faChartLine}
              size={20}
              style={{ color: "#144677" }}
            />
          </div>
          <p className="text-sm font-semibold text-gray-600">ACTIVITY RATIO</p>
        </div>

        <p className="text-4xl font-bold mb-2" style={{ color: "#144677" }}>
          {activityRatio.value}
        </p>

        {renderDelta(activityRatio.delta)}
      </div>

      {/* ===== PROACTIVE TICKETS ===== */}
      <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
        <div className="flex items-center gap-3 mb-3">
          <div
            className="p-3 rounded-lg"
            style={{ backgroundColor: "rgba(255, 98, 102, 0.1)" }}
          >
            <FontAwesomeIcon
              icon={faBolt}
              size={20}
              style={{ color: "#FF6266" }}
            />
          </div>
          <p className="text-sm font-semibold text-gray-600">
            PROACTIVE TICKETS
          </p>
        </div>

        <p className="text-4xl font-bold mb-2" style={{ color: "#FF6266" }}>
          {proactiveRatio.value}%
        </p>

        {renderDelta(proactiveRatio.delta, "%")}
      </div>
    </div>
  );
};

export default ActivityProactiveRatio;
